import { AnyAction } from 'redux';

import { ORDER_RECEIVED } from '@ttstr/actions/orders';
import { IndexedOrders } from '@ttstr/api';

export interface ReduxState {
  orders: IndexedOrders;
}

const initialState: ReduxState = {
  orders: {},
};

const orders = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  switch (action.type) {
    case ORDER_RECEIVED: {
      const { order } = action.payload;

      if (!order) return state;

      return {
        ...state,
        orders: {
          ...state.orders,
          [order.id]: order,
        },
      };
    }
    default:
      return state;
  }
};

export const getOrder = (orders: IndexedOrders, orderId: number) => {
  return orders?.[orderId];
};

export default orders;
